export enum WebSocketType {
	ORDERS,
	TABLES_PAYMENT
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/websocket.enum.ts